<template>
  <RefundsPolicySection ref="refundsPolicy"></RefundsPolicySection>
</template>

<script>
  import RefundsPolicySection from "./RefundsPolicySection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "RefundsPolicyWrapper",
    components: {
      RefundsPolicySection,
    },
    BeforeRouteEnter,
  };
</script>
